import React, { useState, useEffect } from 'react';

function AccessTab({ user }) {
  const [requests, setRequests] = useState([]);
  const [providerUploads, setProviderUploads] = useState([]);
  const [providerRequests, setProviderRequests] = useState([]);
  const [approvedProviders, setApprovedProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchAll();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [res, provRes, provReqRes, approvedRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/api/Access/requests/${user.id}`),
        fetch(`${process.env.REACT_APP_API_URL}/api/Provider/pending/${user.id}`),
        fetch(`${process.env.REACT_APP_API_URL}/api/ProviderAccess/patient-requests/${user.id}`),
        fetch(`${process.env.REACT_APP_API_URL}/api/ProviderAccess/approved-by-patient/${user.id}`),
      ]);
      setRequests(await res.json());
      setProviderUploads(await provRes.json());
      setProviderRequests(await provReqRes.json());
      if (approvedRes.ok) setApprovedProviders(await approvedRes.json());
    } catch { }
    setLoading(false);
  };

  const handleApprove = async (id) => {
    await fetch(`${process.env.REACT_APP_API_URL}/api/Access/approve`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId: id }) });
    setMessage('✅ Access approved!'); fetchAll();
  };
  const handleDeny = async (id) => {
    await fetch(`${process.env.REACT_APP_API_URL}/api/Access/reject`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId: id }) });
    setMessage('Access denied.'); fetchAll();
  };
  const handleRevoke = async (id) => {
    await fetch(`${process.env.REACT_APP_API_URL}/api/Access/revoke`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId: id }) });
    setMessage('Access revoked.'); fetchAll();
  };
  const handleAcceptReport = async (uploadId) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/Provider/accept/${uploadId}`, { method: 'POST' });
      const data = await res.json();
      setMessage('✅ ' + data.message); fetchAll();
    } catch { setMessage('❌ Cannot connect to server.'); }
  };
  const handleRejectReport = async (uploadId) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/api/Provider/reject/${uploadId}`, { method: 'POST' });
      setMessage('Report rejected.'); fetchAll();
    } catch { }
  };
  const handleApproveProvider = async (id) => {
    await fetch(`${process.env.REACT_APP_API_URL}/api/ProviderAccess/approve/${id}`, { method: 'POST' });
    setMessage('✅ Provider access approved!'); fetchAll();
  };
  const handleRejectProvider = async (id) => {
    await fetch(`${process.env.REACT_APP_API_URL}/api/ProviderAccess/reject/${id}`, { method: 'POST' });
    setMessage('Provider access rejected.'); fetchAll();
  };
  const handleRevokeProvider = async (id) => {
    await fetch(`${process.env.REACT_APP_API_URL}/api/ProviderAccess/reject/${id}`, { method: 'POST' });
    setMessage('Provider access revoked.'); fetchAll();
  };

  const pending = requests.filter(r => r.status === 'pending');
  const approved = requests.filter(r => r.status === 'approved');

  return (
    <div className="px-4 py-4 space-y-6">

      {message && (
        <div className={`p-3 rounded-xl text-sm ${message.includes('✅') ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-gray-50 text-gray-600 border border-gray-200'}`}
          onClick={() => setMessage('')}>
          {message}
        </div>
      )}

      {loading && <p className="text-center text-gray-400 text-sm py-6">Loading...</p>}

      {/* ═══ DOCTOR ACCESS ═══ */}
      <section>
        <div className="mb-3">
          <h2 className="text-lg font-black text-[#191c1e]">Doctor Access</h2>
          <p className="text-xs text-gray-400">Control which doctors can view your health records</p>
        </div>

        <div className="bg-[#003d9b]/5 border border-[#003d9b]/20 rounded-2xl p-3 mb-3 flex gap-2">
          <span className="material-symbols-outlined text-[#003d9b] shrink-0" style={{ fontSize: '18px', fontVariationSettings: '"FILL" 1' }}>shield</span>
          <p className="text-xs text-[#003d9b]/80">Only approved doctors can see your records. Revoke anytime.</p>
        </div>

        {/* Doctor Pending */}
        {pending.length > 0 && (
          <div className="mb-3">
            <div className="flex items-center gap-2 mb-2">
              <p className="text-xs font-bold text-gray-500 uppercase tracking-wider">Pending</p>
              <span className="px-2 py-0.5 bg-red-500 text-white text-xs font-bold rounded-full">{pending.length}</span>
            </div>
            <div className="space-y-2">
              {pending.map(req => (
                <div key={req.id} className="bg-white rounded-2xl border-2 border-[#003d9b]/20 shadow-sm p-4">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-11 h-11 bg-[#003d9b] rounded-full flex items-center justify-center text-white font-black">{(req.doctorName || 'D').charAt(0)}</div>
                    <div className="flex-1">
                      <p className="font-bold text-[#191c1e] text-sm">{req.doctorName || `Doctor #${req.doctorId}`}</p>
                      <p className="text-xs text-[#003d9b] font-semibold">{req.doctorSpecialization}</p>
                      <p className="text-xs text-gray-400">{new Date(req.requestedAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <button onClick={() => handleApprove(req.id)} className="py-2.5 bg-[#003d9b] text-white font-bold rounded-xl text-xs active:scale-95">✓ Approve</button>
                    <button onClick={() => handleDeny(req.id)} className="py-2.5 border border-gray-200 text-gray-600 font-bold rounded-xl text-xs active:scale-95">✗ Deny</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Doctor Active */}
        <div>
          <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Active ({approved.length})</p>
          {approved.length === 0 ? (
            <div className="bg-white rounded-2xl p-5 text-center border border-gray-100 shadow-sm">
              <span className="text-2xl">🔒</span>
              <p className="text-gray-400 font-semibold mt-2 text-sm">No active doctor permissions</p>
            </div>
          ) : (
            <div className="space-y-2">
              {approved.map(req => (
                <div key={req.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#003d9b]/10 rounded-full flex items-center justify-center text-[#003d9b] font-black text-sm">{(req.doctorName || 'D').charAt(0)}</div>
                    <div>
                      <p className="font-bold text-[#191c1e] text-sm">{req.doctorName}</p>
                      <p className="text-xs text-gray-400">{req.doctorSpecialization}</p>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    <span className="px-2 py-0.5 bg-green-100 text-green-600 text-xs font-bold rounded-full">✓ Active</span>
                    <button onClick={() => handleRevoke(req.id)} className="text-xs text-red-500 font-bold">Revoke</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ═══ PROVIDER ACCESS ═══ */}
      <section>
        <div className="mb-3">
          <h2 className="text-lg font-black text-[#191c1e]">Lab / Provider Access</h2>
          <p className="text-xs text-gray-400">Control which labs can upload reports to your account</p>
        </div>

        {/* Provider Pending Requests */}
        {providerRequests.length > 0 && (
          <div className="mb-3">
            <div className="flex items-center gap-2 mb-2">
              <p className="text-xs font-bold text-gray-500 uppercase tracking-wider">Pending</p>
              <span className="px-2 py-0.5 bg-red-500 text-white text-xs font-bold rounded-full">{providerRequests.length}</span>
            </div>
            <div className="space-y-2">
              {providerRequests.map(req => (
                <div key={req.id} className="bg-white rounded-2xl border-2 border-[#0f9488]/30 shadow-sm p-4">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: '#e2f7f3' }}>
                      <span className="material-symbols-outlined" style={{ fontSize: '22px', color: '#0f9488', fontVariationSettings: '"FILL" 1' }}>science</span>
                    </div>
                    <div className="flex-1">
                      <p className="font-bold text-sm text-[#191c1e]">{req.providerName}</p>
                      <p className="text-xs text-gray-400">Requesting permission to upload reports</p>
                      <p className="text-xs text-gray-300">{new Date(req.requestedAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                    </div>
                    <span className="text-xs font-bold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 shrink-0">Pending</span>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <button onClick={() => handleRejectProvider(req.id)}
                      className="py-2.5 border-2 border-red-200 text-red-600 font-bold rounded-xl text-xs active:scale-95">✗ Reject</button>
                    <button onClick={() => handleApproveProvider(req.id)}
                      className="py-2.5 text-white font-bold rounded-xl text-xs active:scale-95"
                      style={{ background: '#0f9488' }}>✓ Approve</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Provider Active */}
        <div>
          <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Active ({approvedProviders.length})</p>
          {approvedProviders.length === 0 ? (
            <div className="bg-white rounded-2xl p-5 text-center border border-gray-100 shadow-sm">
              <span className="text-2xl">🏥</span>
              <p className="text-gray-400 font-semibold mt-2 text-sm">No active lab permissions</p>
            </div>
          ) : (
            <div className="space-y-2">
              {approvedProviders.map(req => (
                <div key={req.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: '#e2f7f3' }}>
                      <span className="material-symbols-outlined" style={{ fontSize: '18px', color: '#0f9488', fontVariationSettings: '"FILL" 1' }}>science</span>
                    </div>
                    <div>
                      <p className="font-bold text-[#191c1e] text-sm">{req.providerName}</p>
                      <p className="text-xs text-gray-400">Lab / Diagnostic Provider</p>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    <span className="px-2 py-0.5 bg-green-100 text-green-600 text-xs font-bold rounded-full">✓ Active</span>
                    <button onClick={() => handleRevokeProvider(req.id)} className="text-xs text-red-500 font-bold">Revoke</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ═══ LAB REPORTS PENDING ═══ */}
      {providerUploads.length > 0 && (
        <section>
          <div className="flex items-center gap-2 mb-3">
            <h2 className="text-lg font-black text-[#191c1e]">Lab Reports Pending</h2>
            <span className="w-5 h-5 bg-purple-500 text-white text-xs font-bold rounded-full flex items-center justify-center">{providerUploads.length}</span>
          </div>
          <div className="space-y-3">
            {providerUploads.map(upload => (
              <div key={upload.id} className="bg-white rounded-2xl border-2 border-purple-200 shadow-sm p-4">
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 bg-purple-50 rounded-xl flex items-center justify-center shrink-0">
                    <span className="material-symbols-outlined text-purple-600" style={{ fontSize: '20px', fontVariationSettings: '"FILL" 1' }}>description</span>
                  </div>
                  <div className="flex-1">
                    <p className="font-bold text-[#191c1e] text-sm">{upload.fileName}</p>
                    <p className="text-xs text-gray-400">{upload.reportType} • {upload.hospitalName}</p>
                    <p className="text-xs text-gray-400">{new Date(upload.uploadedAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                  </div>
                </div>
                <p className="text-xs text-purple-600 font-semibold mb-3">A lab has uploaded this report. Accept to add to your health records.</p>
                <div className="grid grid-cols-2 gap-2">
                  <button onClick={() => handleAcceptReport(upload.id)}
                    className="py-2.5 bg-[#003d9b] text-white font-bold rounded-xl text-xs active:scale-95">✓ Accept</button>
                  <button onClick={() => handleRejectReport(upload.id)}
                    className="py-2.5 border border-gray-200 text-gray-600 font-bold rounded-xl text-xs active:scale-95">✗ Reject</button>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default AccessTab;